import {
  Directive,
  Input,
  OnInit,
  ElementRef,
  HostListener,
  inject,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[digitalPlatformZipcodeFormat]',
  standalone: true,
})
export class ZipcodeFormatDirective implements OnInit {
  @Input() digitalPlatformZipcodeFormat: 'US' | 'MX' | 'CA' = 'US';
  private ngControl = inject(NgControl);

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.formatValue(this.ngControl.control?.value);
  }

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const value = input.value;
    this.formatValue(value);
  }

  private formatValue(value: string): void {
    let formattedValue: string;

    switch (this.digitalPlatformZipcodeFormat) {
      case 'US':
        formattedValue = this.formatUS(value);
        break;
      default:
        formattedValue = value;
    }

    this.ngControl.control?.setValue(formattedValue, { emitEvent: false });
    this.el.nativeElement.value = formattedValue;
  }

  private formatUS(value: string): string {
    if (!value) return '';

    const cleanValue = value.replace(/\D/g, '');
    if (cleanValue.length <= 5) {
      return cleanValue;
    } else if (cleanValue.length === 9) {
      return `${cleanValue.substring(0, 5)}-${cleanValue.substring(5, 9)}`;
    }
    return `${cleanValue.substring(0, 5)}-${cleanValue.substring(5, 9)}`;
  }
}
